import { AuthContext } from 'context/auth';
import { difference, intersection } from 'lodash';
import { useContext, useMemo } from 'react';
import { UserModel } from '../../services/Models/UserModel';

export type PermissionType = string | string[];
export type PermissionCondition = 'AND' | 'OR';

export const useHasPermissions = (
  permission?: PermissionType,
  condition: PermissionCondition = 'AND'
) => {
  const { currentUser } = useContext(AuthContext);

  const isAuthorized = useMemo(
    () => {
      // se non passo un permesso o uso *
      if (!permission || permission === '*') return true;
      if (permission === 'NO' || permission === 'negate') return false;
      return hasPermissions(currentUser, permission, condition);
    },
    // user.permissions.includes(permission) === true,
    [currentUser?.permissions]
  );

  return isAuthorized;
};

export const checkUserHasRole = (user: UserModel, roles: string | string[]) => {

  let hasRole = false;
  const checkedRoles = (typeof user?.roles === 'object') ? Object.keys(user?.roles) : user?.roles

  checkedRoles?.filter((userRole) => {
    if (typeof roles === 'string') {
      if (userRole.toLowerCase() === roles.toLowerCase()) {
        hasRole = true;
      }
    } else {
      const found = roles.find((role) => role.toLocaleLowerCase() === userRole.toLowerCase());
      if (found) hasRole = true;
    }
  });
  return hasRole;
};

export const hasPermissions = (
  user: UserModel,
  permission?: PermissionType,
  condition: PermissionCondition = 'AND'
) => {
  //return true;
  const permissionsToCheck = Array.isArray(permission) ? permission : [permission];

  const harAllPermissions = difference(permissionsToCheck, user.permissions).length === 0
  const isAutorized =
    condition === 'AND'
      ? // AND check for all permissions
      harAllPermissions
      : // OR Check if has at least one permission
      intersection(permissionsToCheck, user.permissions).length > 0;

  return isAutorized;
};

